import {useEffect} from "react";

/**
 * Note: after checking (https://github.com/prerender/prerender/issues/85), I realized that this window.prerenderReady
 *  does not actually speed up the caching process. It would be only in cases where I want to tell Prerender.io to wait
 *  a bit longer until an action is done before Prerender.io can start caching the page. That's a bit disappointing.
 *  https://docs.prerender.io/docs/how-to-test-your-site-after-you-have-successfully-validated-your-prerender-integration
 *
 * Prerender.io uses a best-effort approach to determine when the page has finished loading in order to start caching
 * the HTML content. Sometimes, it may start caching before all the content is ready. Therefore, it's a good practice
 * to inform Prerender.io when the page is ready for caching to get more consistent results. However, it does not speed
 * things up.
 * - https://docs.prerender.io/docs/11-best-practices
 */
export default function usePrerenderIo() {
    useEffect(() => {
        // note: the 'false' part is done in PHP Elementor widget since Prerender.io requires it as early as possible
        // tell Prerender.io to not grab HTML content yet since page is not fully rendered
        // window.prerenderReady = false;
        // console.log("prerender-ready = false");

        // watch for presence of 'tiny_brokers' class, which is a good indicator that the page is mostly rendered
        const observer = new MutationObserver(mutations => {
            for (const mutation of mutations) {
                if (mutation.type !== 'childList') continue;
                if (!document.querySelector('.tiny_brokers')) continue;

                // when 'tiny brokers' node is found, tell Prerender.io that the page is ready for consumption
                window.prerenderReady = true;
                console.log("prerender-ready = true");
                // debugger; // note: very useful to trigger browser dev console breakpoint for debugging
                observer.disconnect();
                break;
            }
        });
        observer.observe(document.body, {childList: true, subtree: true});
        return () => observer.disconnect();
    }, []);
}